<template>
  <div>
    <h1 class="tit">#<strong>botalab</strong> Instagram</h1>
    <p class="sub-copy">
      Share your moment and meet the light of INCELLDERM
    </p>
  </div>
</template>

<script>
export default {
  name: 'SnsTitle',
};
</script>

<style></style>
